
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import { useIsMobile } from '@/hooks/use-mobile';
import { Button } from '@/components/ui/button';
import { ChevronUp } from 'lucide-react';

interface LegalFooterProps {
  onBackToTop: () => void;
}

const LegalFooter: React.FC<LegalFooterProps> = ({ onBackToTop }) => {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage];
  const isMobile = useIsMobile();
  
  return (
    <footer className="mt-8 md:mt-12 pt-4 md:pt-6 bg-gradient-to-b from-secondary/40 to-black/80 border-t border-purple-500/30 rounded-lg px-4 py-4 backdrop-blur-sm shadow-[0_0_15px_rgba(139,92,246,0.15)]">
      <div className="flex flex-col md:flex-row items-center md:justify-between gap-3 md:gap-0">
        <p className="text-xs md:text-sm text-gray-400 animate-fade-in font-future">{t.lastUpdated}</p>
        <Button 
          variant="ghost" 
          size="sm"
          className="text-purple-400 hover:text-purple-300 hover:bg-purple-500/10 focus-visible:ring-2 focus-visible:ring-purple-500 focus-visible:ring-offset-2 focus-visible:ring-offset-black group animate-fade-in"
          onClick={(e) => {
            e.preventDefault();
            onBackToTop();
          }}
          aria-label={t.backToTop}
        >
          <ChevronUp className="h-4 w-4 mr-1 group-hover:animate-bounce" aria-hidden="true" />
          <span className="font-future bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-purple-300">{t.backToTop}</span>
        </Button>
      </div>
    </footer>
  );
};

export default LegalFooter;
